export interface ITimelinePoint {
  month: string;
  value: number;
  previous_year?: number | null;
}

export const getStatusMeta = (status: any): {
  label: string;
  modifier: 'delayed' | 'on-track';
} | null => {
  const raw = (status || '').toString().trim();
  if (!raw) return null;

  const normalized = raw.toLowerCase().replace(/[_-]/g, ' ');
  if (normalized === 'delayed') {
    return { label: 'Delayed', modifier: 'delayed' };
  }
  if (normalized === 'on track') {
    return { label: 'On Track', modifier: 'on-track' };
  }
  return null;
};

// 根据 timeline: [{month, value}, ...] 构造 LineChart 配置
export const buildTrendData = (
  timeline: Array<ITimelinePoint> | undefined,
  metricKey: string,
) => {
  const safeTimeline = Array.isArray(timeline) ? timeline : [];
  const xAxisData = safeTimeline.map((p) => p?.month);
  const thisMonthSeriesData = safeTimeline.map((p) => {
    if (p?.value === null || p?.value === undefined || isNaN(Number(p?.value))) {
      return null;
    }
    return Number(p.value);
  });
  const previousYearSeriesData = safeTimeline.map((p) => {
    const previousYear = p?.previous_year;
    if (previousYear === null || previousYear === undefined || isNaN(Number(previousYear))) {
      return null;
    }
    return Number(previousYear);
  });

  return {
    xAxisData,
    metrics_name: metricKey,
    series: [
      {
        name: 'This Month',
        type: 'line',
        color: '#7F6FF1',
        showSymbol: false,
        itemStyle: {
          color: '#7F6FF1',
        },
        lineStyle: {
          type: 'solid',
          color: '#7F6FF1',
        },
        areaStyle: {
          opacity: 0.25,
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: '#7F6FF1' },
              { offset: 1, color: '#FFF' },
            ],
          },
        },
        data: thisMonthSeriesData,
      },
      {
        name: 'Same Month Last Year',
        type: 'line',
        color: '#74CDF6',
        showSymbol: true,
        itemStyle: {
          color: '#74CDF6',
        },
        lineStyle: {
          type: 'dotted',
          color: '#74CDF6',
        },
        areaStyle: {
          opacity: 0.25,
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: '#74CDF6' },
              { offset: 1, color: '#FFF' },
            ],
          },
        },
        data: previousYearSeriesData,
      },
    ],
  };
};

// spend_to_date / headcount 主数值取 value
export const getMetricNumericValue = (
  metricKey: 'spend_to_date' | 'headcount',
  project: any,
): number | null => {
  if (metricKey === 'spend_to_date') {
    const v = project?.spend_to_date?.value;
    return v === null || v === undefined ? null : Number(v);
  }
  const v = project?.headcount?.value;
  return v === null || v === undefined ? null : Number(v);
};
